import {FC} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {IMAGES_URL} from "modules/constants";
import {BaseExternalLink} from "components/Common/Links";
import {ReactComponent as Arrow} from "assets/images/icons/playerDetailsModal/arrow.svg";
import {breakpoints} from "assets/theme";

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	background: ${({theme}) => theme.colorPalette.black};
	color: ${({theme}) => theme.colorPalette.white};
	font-family: "Hind", sans-serif;
	text-align: left;
	min-height: 150px;

	@media (min-width: ${breakpoints.medium}) {
		flex-direction: row;
	}
`;

const Img = styled.img`
	width: 100%;
	object-fit: cover;

	@media (min-width: ${breakpoints.medium}) {
		width: 50%;
		min-height: 100%;
	}
`;

const Content = styled.div`
	flex-grow: 1;
	padding: 12px 20px;
`;

const Head = styled.div`
	display: flex;
	gap: 4px;
	justify-content: space-between;
	border-bottom: 1px solid ${({theme}) => theme.colorPalette.primary};
	padding-bottom: 8px;
`;

const Title = styled.div`
	font-weight: 700;
	font-size: 16px;
	line-height: 120%;
	letter-spacing: 0.02em;
`;

const Link = styled(BaseExternalLink)`
	white-space: nowrap;
	color: ${({theme}) => theme.colorPalette.secondary};
`;

const Desc = styled.div`
	margin-top: 12px;
`;

interface INewsArticle {
	title: string;
	desc: string;
	src?: string;
	link?: string;
}

export const NewsArticle: FC<INewsArticle> = ({desc, title, src = "", link}) => {
	const {t} = useTranslation();

	return (
		<Wrapper>
			{src && <Img src={`${IMAGES_URL}${src}`} />}

			<Content>
				<Head>
					<Title>{title}</Title>

					{link && (
						<Link href={link}>
							<span>{t("player_profiles.tab.news.link")}</span>
							<Arrow />
						</Link>
					)}
				</Head>

				<Desc
					dangerouslySetInnerHTML={{
						__html: desc,
					}}
				/>
			</Content>
		</Wrapper>
	);
};
